module.exports = __webpack_public_path__ + "static/media/dashboard.fe1cdf1d.svg";